import cdnConfig from './cdn.config.json'

/* global __webpack_public_path__:writable */
/* exported __webpack_public_path__ */

export const CDN = (() => {
  const state = {
    cdnUrl: ''
  }

  const getCdnUrl = () => state.cdnUrl

  const getParentUrl = () => {
    const { protocol, hostname } = window.location
    
    return `${protocol}://${hostname}`
  }

  const updateCdnUrl = async (renderingMode = '') => {
    let cdnUrl = ''

    if (renderingMode === 'widget') {
      cdnUrl = _getCdnUrl()
    } else if (renderingMode === 'app') {
      cdnUrl = '/'
    } else {
      throw new Error('redneringMode is not supported!')
    }

    __webpack_public_path__ = cdnUrl // NOSONAR
    state.cdnUrl = cdnUrl
  }

  return {
    updateCdnUrl,
    getCdnUrl,
    getParentUrl
  }
})()

/**
 * @private
 * @description This method takes script source (https://sportsmode.ug.cdn.united.cloud/smw-engine) and takes out scripts part in order to get original cdn url
 *
 * @param { String } scriptSource is a src url from <script script-id="sports-mode" src="..."> which will be used if rendering mode is a "widget"
 * @returns { String } should return formed cdn url (example: https://sportsmode.ug.cdn.united.cloud/)
 */
const _getCdnUrl = () => {
  const sportsModeScript = document.querySelector('[script-id="sports-mode"]')
  const scriptSource = sportsModeScript.src

  const isLocalhost = scriptSource.includes('localhost') || scriptSource.includes('192.168.') || scriptSource.includes(':3000')

  const cdnUrl = isLocalhost ? 'http://localhost:3000/' : scriptSource.split('united.cloud/')[0] + 'united.cloud/'

  /* chech if cdnUrl is available (white-listed) */
  const doesCdnUrlExist = !!cdnConfig.availableCdns.find(cdn => cdn.url === cdnUrl)

  if (!doesCdnUrlExist) {
    throw new Error(`Cdn url: ${cdnUrl} is not allowed!`)
  }

  return cdnUrl
}
